// extracted by mini-css-extract-plugin
export default {"addWarehouseSection":"style_addWarehouseSection__0vd5c","actionsSection":"style_actionsSection__jwfVp","formSection":"style_formSection__Vi03t"};